import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const PeopleIcon = React.memo(
  ({ fill = variables['colors-mc-primary'], width = '70', viewBox = '0 0 70 70' }) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={remCss(width)}
      height={remCss(width)}
      viewBox={viewBox}
    >
      <g id='trafic' transform='translate(0 -0.5)'>
        <rect
          id='Rectangle_889'
          data-name='Rectangle 889'
          width='70'
          height='70'
          transform='translate(0 0.5)'
          fill='none'
        />
        <g id='people-fill' transform='translate(0 14.5)'>
          <path
            id='Path_11220'
            data-name='Path 11220'
            d='M9.25,41A3.183,3.183,0,0,1,6,37.75c0-3.25,3.25-13,16.25-13s16.25,9.75,16.25,13A3.183,3.183,0,0,1,35.25,41Zm13-19.5a9.75,9.75,0,1,0-9.75-9.75A9.75,9.75,0,0,0,22.25,21.5Z'
            transform='translate(13.5)'
            fill={fill}
          />
          <path
            id='Path_11221'
            data-name='Path 11221'
            d='M16.952,25.251a7.273,7.273,0,0,1-.7-3.25,15.511,15.511,0,0,1,6.292-12.09A20.556,20.556,0,0,0,16.25,9C3.25,9,0,18.751,0,22a3.183,3.183,0,0,0,3.25,3.25Z'
            transform='translate(0 15.749)'
            fill={fill}
            fillRule='evenodd'
          />
          <path
            id='Path_11222'
            data-name='Path 11222'
            d='M10.125,19.25A8.125,8.125,0,1,0,2,11.125,8.125,8.125,0,0,0,10.125,19.25Z'
            transform='translate(4.5 2.25)'
            fill={fill}
          />
        </g>
      </g>
    </svg>
  )
);
PeopleIcon.displayName = 'PeopleIcon';

export default PeopleIcon;
